import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { isSafari } from '#src/app/shared/utils/userAgent';

import { safeCanPlayType } from './safeCanPlayType';

export function canPlayWebm(utilityContext: UtilityContext): boolean {
	// Webm is not supported
	if (safeCanPlayType('video/webm') === '') {
		return false;
	}

	// This handles current flakey canPlayType for Mac Safari, which returns 'maybe' even when not supported.
	if (isSafari(utilityContext)) {
		return false;
	}

	return true;
}
